import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetSummary } from "../../../Redux/Reducers/Manager/Summary";
import { GetSpecificTaskById } from "../../../Redux/Reducers/Manager/Tasks/TasksByRoundAndFiled";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import InputAHSF from "../../../Components/InputAHSF";
import { useParams } from "react-router-dom";
import BudgetItemsRequestedFromSomanManager from "../BudgetItemsRequestedFromSoman";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";

function SummaryInfo(props) {
  const dispatch = useDispatch();
  // const { taskId } = useParams();

  const state = useSelector((state) => {
    return {
      Summary: state.Summary.Summary,
      SpecificTask:
        state.TasksByRoundAndFiled.SpecificTask?.applicationInformationId,
    };
  });
  const jsonData = useSelector((state) => state.FetchDataJson.JsonData);

  const getData = async () => {
    const result = await dispatch(
      GetSpecificTaskById({ taskId: props.taskId })
    );

    if (result?.payload?.applicationInformationId) {
      dispatch(
        GetSummary({
          applicationInformationId: result?.payload?.applicationInformationId,
        })
      );
    }
  };

  useEffect(() => {
    getData();
  }, [props.taskId]);
  console.log(state?.Summary, "ssssssssssdwdwd");

  return (
    <>
      {state?.Summary ? (
        <>
          <SharedDiv
            showTitle={true}
            titleName="ملخص الطلب"
            child={[
              <div className="form-grid" key="info-grid">
                <InputAHSF
                  fieldsName="researcherName"
                  show={true}
                  disabled={true}
                  value={state.Summary?.researcherName}
                />
                <InputAHSF
                  fieldsName="uiversity"
                  show={true}
                  disabled={true}
                  value={state.Summary?.university}
                />
                <InputAHSF
                  fieldsName="projectName"
                  show={true}
                  disabled={true}
                  value={state.Summary?.projectName}
                />
                <TextAreaAHSF
                  fieldsName="introduction"
                  show={true}
                  disabled={true}
                  value={state.Summary?.introduction}
                />
                <TextAreaAHSF
                  fieldsName="methodologyName"
                  show={true}
                  disabled={true}
                  value={state.Summary?.methodologyName}
                />
                <TextAreaAHSF
                  fieldsName="expectedImpact"
                  show={true}
                  disabled={true}
                  value={state.Summary?.expectedImpact}
                />
              </div>,
            ]}
          />
        </>
      ) : (
        <></>
      )}

      <SharedDiv
        showTitle={true}
        titleName={jsonData ? jsonData?.itemsRequestedFromShoman?.nameAR : ""}
        child={[<BudgetItemsRequestedFromSomanManager />]}
      />
    </>
  );
}

export default SummaryInfo;
